'use client';

import { ArrowRight } from 'lucide-react';
import Image from 'next/image';
import { useCreateListing, type StepId } from '../_context';

type ListingTypeCard = {
  title: string;
  description: string;
  target: StepId;
  image: { src: string; width: number; height: number; className: string };
};

// Sizes are Figma node 33:69 measurements, 1:1 (project root: 1rem = 8px).
const LISTING_TYPE_CARDS: ListingTypeCard[] = [
  {
    title: 'Gear, Parts & Accesories',
    description: 'Tech 10s, FMF Exhaust, Tent, etc.',
    target: 'search',
    image: {
      src: '/images/create-listing/gear-card.png',
      width: 240,
      height: 240,
      // Figma 80×80
      className: 'h-[10rem] w-[10rem] object-contain',
    },
  },
  {
    title: 'Vehicle for Sale',
    description: 'Dirt Bike, ATV, UTV, Street Bike, etc.',
    target: 'find-vehicle',
    image: {
      src: '/images/create-listing/vehicle-card.png',
      width: 140,
      height: 80,
      // Figma 140×80
      className: 'h-[10rem] w-[17.5rem] object-contain',
    },
  },
];

export default function SelectListingType() {
  const { goToStep } = useCreateListing();

  return (
    <div className="mx-auto flex w-full max-w-[99rem] flex-col gap-[3rem] px-[2rem] pt-[5rem]">
      <h1 className="text-[3rem] font-bold leading-[1.3] tracking-[-0.03rem] text-black">
        What are you selling?
      </h1>

      <div className="flex flex-col gap-[1.5rem] sm:flex-row">
        {LISTING_TYPE_CARDS.map((card) => (
          <button
            key={card.target}
            type="button"
            onClick={() => goToStep(card.target)}
            className="flex flex-1 flex-col items-start justify-center gap-[2rem] rounded-[1.5rem] border border-[#ededed] bg-white p-[3rem] text-left transition-colors hover:border-brand-secondary"
          >
            <Image
              src={card.image.src}
              alt=""
              width={card.image.width}
              height={card.image.height}
              className={card.image.className}
            />

            <div className="flex w-full items-center justify-end gap-[1.25rem]">
              <div className="flex flex-1 flex-col">
                <span className="text-[2rem] font-semibold leading-[1.5] text-black">
                  {card.title}
                </span>
                <span className="text-[1.5rem] font-medium leading-[1.4] text-[#444]">
                  {card.description}
                </span>
              </div>

              <div className="flex h-[3rem] w-[3rem] flex-shrink-0 items-center justify-center rounded-full bg-[#d9d9d9]">
                <ArrowRight className="h-[1.5rem] w-[1.5rem] text-black" />
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
